import gql from 'graphql-tag';
import className from 'classnames/bind';
import { LogosFragment } from '@graphqlTypes';
import { Container, SectionHeader, RevealWrapper, HeadlineAnim } from '@components';
import styles from './Logos.module.scss';
import Logo from './Logo';
import LogoCarousel from './LogoCarousel';
import { useRef } from 'react';
import { useInView } from 'motion/react';
import { useViewSize } from '@/providers/ViewSizeContext';
import { AnimVals } from '@/utils/animUtils';
const cx = className.bind(styles);

export default function Logos(props: LogosFragment) {
  const { headline, body, logos } = props;
  const hasCarousel = logos?.length > 12;
  const showHeader = Boolean(headline || body);

  // -------------------- Animation

  const rootEl = useRef<HTMLElement | null>(null);
  const { isDesktop } = useViewSize();
  const REVEAL = AnimVals;
  const triggerPercent = isDesktop ? REVEAL.lg.triggerPercent : REVEAL.sm.triggerPercent;
  const isInView = useInView(rootEl, { amount: triggerPercent, once: REVEAL.once });
  const isRevealEnabled = true;

  // -------------------- Render

  return (
    <section className={cx(["logos"])} ref={rootEl}>
      <RevealWrapper isInView={isInView}>
        {showHeader && (
          <Container>
            <SectionHeader
              headline={headline}
              subhead={body}
              isRevealEnabled={isRevealEnabled}
              isInView={isInView}
            />
          </Container>
        )}
        {hasCarousel ? (
          <LogoCarousel logos={logos} />
        ) : (
          <Container>
            <div className={cx("logos-grid")}>
              {logos.map((logo, index) => (
                <Logo key={index} {...logo} />
              ))}
            </div>
          </Container>
        )}
      </RevealWrapper>
    </section>
  )
}

Logos.fragments = {
  entry: gql`
    fragment Logos on FlexiblePageContentContentLogosLayout {
      headline
      body
      logos {
        logo {
          ... ACFMedia
        }
      }
    }
  `,
};
